import React from "react";
import withRedux from "../withRedux";
import cx from "classnames";

const Flashes = ({ flashes }) => {
	return (
		<div className="flashAlerts">
			{ flashes.map(message => {
				const className = cx({
					"error": message.type === "error",
					"success": message.type === "success",
					"info": message.type === "info"
				});
				return (
					<div className={`flashAlert ${className}`} role="alert" key={message.id}>
						<div className="icon" />
						<div className="message">{message.text}</div>
					</div>
				);
			} )}
		</div>
	);
};
const mapStateToProps = ({ flashes }, ownProps) => {
	return { flashes };
};

export default withRedux(null, mapStateToProps)(Flashes);
